import { baseURL } from "../constants/env";
import AvatarIcon from "../public/images/avatar.png";

// Photo de profil de l'élève. Des fichiers envoyés en 2020-2022 n'existent
// plus sur le serveur (404) : on affiche alors l'avatar par défaut au lieu
// d'une image cassée.
export const avatarSrc = (picture) =>
  picture ? baseURL + picture : AvatarIcon;

export const showDefaultAvatar = (event) => {
  const img = event.currentTarget;
  if (img.dataset.fallback) return; // l'avatar par défaut a aussi échoué
  img.dataset.fallback = "true";
  img.src = AvatarIcon;
};
